import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const getFileDataResults = async ({ testcaseresultid, page, pageSize }) => {
  const user = getUserDetails();
  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getFileDataResults&companyid=${user.companyid}&testcaseresultid=${testcaseresultid}&page=${page}&pageSize=${pageSize}`,
  );
  return response.data;
};

export const useGetFileDataResultsQuery = (testcaseresultid, page = 1, pageSize = 10, options = {}) => {
  return useQuery({
    queryKey: ["getFileDataResults", testcaseresultid, page, pageSize],
    queryFn: () => getFileDataResults({ testcaseresultid, page, pageSize }),
    enabled: !!testcaseresultid,
    ...options,
  });
};

export default useGetFileDataResultsQuery;
